// Supabase singleton
// see architecture.md#L650

import { createClient } from '@supabase/supabase-js';

let _client = null;

export function getSupabase() {
  if (_client) return _client;

  const url = import.meta.env.VITE_SUPABASE_URL;
  const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

  if (!url || !key) {
    console.error('[supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY');
    // 在 dev 環境 fallback，避免整個 app 炸掉
    _client = {
      auth: {
        getSession: async () => ({ data: null }),
        onAuthStateChange: () => {},
        signInWithOtp: async () => ({ error: new Error('Supabase 未設定，請檢查 .env.local') }),
      },
      from: () => ({ select: async () => ({ data: [], error: null }) }),
    };
    return _client;
  }

  _client = createClient(url, key, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
    realtime: {
      params: { eventsPerSecond: 5 },
    },
  });

  return _client;
}

// Read tenant_id from current session JWT payload (same claim RLS sees).
// Codex W1 重要 #3：不再讀 app_metadata，以 JWT top-level claim 為唯一來源。
export async function getTenantIdFromJwt() {
  const client = _client;
  if (!client) return null;
  const { data } = await client.auth.getSession();
  const token = data?.session?.access_token;
  if (!token) return null;
  try {
    let b64 = token.split('.')[1];
    if (!b64) return null;
    b64 = b64.replace(/-/g, '+').replace(/_/g, '/');
    const pad = b64.length % 4;
    if (pad === 2) b64 += '==';
    else if (pad === 3) b64 += '=';
    else if (pad === 1) return null;
    const payload = JSON.parse(atob(b64));
    return payload?.tenant_id || null;
  } catch {
    return null;
  }
}
